 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		53: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "static/js/" + chunkId + "." + {"0":"d44962f2623b0adee4c1","1":"f53199a6f57b430fb3f3","2":"b081a7431d918094fa70","3":"8ba52ee90055af1b34f3","4":"7fd7c62be401afe031bf","5":"7aec9cb732b08c7228aa","6":"372f6e5d7fdcf3bdad87","7":"1da1c149463a7d4d1ddd","8":"e91385a9c9b19eec7bb4","9":"217866fec85e0347fca4","10":"e9319026d427b88c3cdb","11":"5240895ceab5467cc117","12":"3de95c0da6512dedfecb","13":"067fccdee4e8e9e948db","14":"a73b2f373d6a060c2a82","15":"4bc7a05d526d7408a092","16":"bf24b1c326de3f0b9f75","17":"762925175717e23a40dd","18":"dc9577b50f13622544a9","19":"a3e767b0f2f3697bc455","20":"80e94f901fee85ef1ee1","21":"b9d3c262024b4710c799","22":"41f6f9b43fb3c82a01d2","23":"173ac77531e68aa56ff3","24":"9f278bb53f32f6847f08","25":"d3ae59495d22e3817f7e","26":"fa17654dd599f333ec83","27":"d26ac620a630b5b86dcf","28":"a872c2f880e56b26a4cf","29":"f8ed8a93c6899c3c4380","30":"1e4e05cc4463980f27c5","31":"a4810c389661b7e7a290","32":"65bbb582a7fa4e8e976d","33":"ae03d8ceab265a604088","34":"14390225e66dfa2e93a3","35":"ea2db125d9f212be270b","36":"7be5862fc616c398e9e1","37":"203192d43d1d79cf33de","38":"ebb79b375fbc456aa7c8","39":"da6053fdfdf09f35cfa7","40":"6e8196d0d5bb34fba7a1","41":"ce635b62de8b8225704d","42":"46ba8df92166c358319c","43":"c04bec7c06fbb9f5fa8b","44":"9f381f87a2adfbf8b543","45":"683ce8e7896b24395a30","46":"11cb640c17986d9a2b0b","47":"923dfb035f49a331f8a1","48":"0f377f889a803a9779ed","49":"469b492e590d61a79e73","50":"7d867ecc89e4d17e0f9d"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/ocr/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 38221c861b6ce9b5f6f1